import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, signal } from '@angular/core';
import { TypedChanges } from '@libs/utils';
import { TranslateModule } from '@ngx-translate/core';
import { ToothWithDate } from '@libs/store';
import { ToothComponent } from '../tooth';

@Component({
  selector: 'lib-teeth-highlight',
  imports: [NgClass, ToothComponent, TranslateModule],
  templateUrl: './teeth-highlight.component.html',
  styleUrl: './teeth-highlight.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeethHighlightComponent implements OnChanges {
  @Input({ required: true }) public teeth: ToothWithDate[] = [];
  @Input() set selectedPosition(position: number) {
    this.selectedIndex.set(this.teeth.findIndex((t) => t.position === position));
  }
  @Output() public teethSelect = new EventEmitter<number>();

  protected readonly selectedIndex = signal(0);

  public ngOnChanges(changes: TypedChanges<TeethHighlightComponent>): void {
    if (changes.teeth && changes.teeth.currentValue?.length !== changes.teeth.previousValue?.length) {
      this.setIndexAndEmitPosition(0);
    }
  }

  protected onPageClick(teethIndex: number): void {
    this.setIndexAndEmitPosition(teethIndex);
  }

  protected onNextClick(): void {
    this.setIndexAndEmitPosition(this.selectedIndex() + 1);
  }

  protected onPrevClick(): void {
    this.setIndexAndEmitPosition(this.selectedIndex() - 1);
  }

  private setIndexAndEmitPosition(index: number): void {
    this.selectedIndex.set(index);
    this.teethSelect.emit(this.teeth[index].position);
  }
}
